<template>
    <div>
        <div v-if="visible" class="mx-auto py-5">
            <div class="mx-auto">
                <div class="rounded-md px-4" :class="{'alert-info' : isInfo(), 'alert-warning' : isWarning(), 'alert-error': isError()}">
                    <div class="flex items-start py-3">
                        <div class="flex-shrink-0">
                            <icon v-if="isInfo()" name="alert-info" class="w-5 h-5 font-bold alert-icon-info"/>
                            <icon v-if="isWarning()" name="alert-warning" class="w-5 h-5 font-bold alert-icon-warning"/>
                            <icon v-if="isError()" name="alert-error" class="w-5 h-5 font-bold alert-icon-error"/>
                        </div>
                        <div class="ml-3">
                            <p class="mb-8" v-if="headline && headline.length > 0" v-html="headline"></p>
                            <p v-if="isWarning() && displayErrorsTitle">{{$t('shared.alert_messages.warnings')}}</p>
                            <p v-if="isError() && displayErrorsTitle">{{$t('shared.alert_messages.errors')}}</p>
                            <ul
                                v-if="showAsList && Array.isArray(messages)  && messages.length > 0"
                                class="alert-messages ml-5 pl-4"
                                :key="'list'"
                            >
                                <template v-for="(message, index) in messages">
                                    <li class="pl-2" v-if="message.length > 0" :key="index">
                                        <span class="block sm:inline">{{ message }}</span>
                                    </li>
                                    <br v-if="message.length === 0" :key="'1_' + index">
                                </template>
                            </ul>
                            <div
                                v-if="typeof messages === 'object'"
                                v-for="(errors, idx) in messages"
                                :key="'err_' + idx"
                            >
                                <div v-for="(allErrors, idx) in errors" :key="'e_' + idx">
                                    <span class="text-danger" :key="'s_' + idx">{{ allErrors.message }} </span>
                                </div>
                            </div>
                            <template v-for="(message, index) in messages" v-if="!showAsList && messages && messages.length > 0">
                                <p class="" v-if="message.length > 0" :key="'m_' + index">
                                    <span class="block sm:inline" :key="'s_' + index">{{ message }}</span>
                                </p>
                                <br v-if="message.length === 0" :key="'1_' + index">
                            </template>
                            <slot></slot>
                        </div>
                        <div class="ml-auto pl-3">
                            <div class="-mx-1.5 -my-1.5">
                                <button type="button"
                                        class="inline-flex rounded-md p-1.5 focus:outline-none focus:ring-2 focus:ring-offset-2"
                                        :class="{'alert-close-button-info': isInfo(), 'alert-close-button-warning': isWarning(), 'alert-close-button-error': isError()}"
                                        @click="close()">
                                    <span class="sr-only">{{$t('shared.alert_messages.dismiss')}}</span>
                                    <icon name="alert-dismiss" class="h-5 w-5"></icon>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from "@/Shared/Icon";
import {ErrorTypes} from "../../mixins/ErrorTypes";

export default {
    components: {
        Icon
    },
    mixins: [ErrorTypes],
    name: 'AlertMessages',
    props: {
        errorType: Number,
        headline: String,
        displayErrorsTitle: {
            Type: Boolean,
            default: false
        },
        messages: [],
        showAsList: {
            Type: Boolean,
            default: true
        }
    },
    data() {
        return {
            visible: true
        }
    },
    watch: {
        messages: {
            handler(val){
                this.visible = !!val;
            },
            deep: true
        },
        errorType:  {
            handler(val, oldVal) {
                this.visible = !!val;
            },
            deep: true
        },
        headline:  {
            handler(val, oldVal) {
                this.visible = !!val;
            },
            deep: true
        }
    },
    methods: {
        isInfo() {
            return this.errorType === this.ERROR_TYPE_INFO;
        },
        isWarning() {
            return this.errorType === this.ERROR_TYPE_WARNING;
        },
        isError() {
            return this.errorType === this.ERROR_TYPE_ERROR;
        },
        close() {
            this.visible = false;
            this.$emit('close');
        }
    }
}
</script>
